import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import AdminLoginPage from "@/pages/admin/AdminLoginPage";

export const Route = createFileRoute("/_admin/admin/login")({
  head: () => pageHead("Admin Sign In", "AKIVA admin portal sign-in.", "/admin/login", true),
  component: AdminLoginPage,
});
